import $ from 'jquery'
import { Collapse } from 'bootstrap'
import { tsInitVue, isNonEmptyString } from './js-utils'
import ReimbursementManager from './vue-components/reimbursement-manager.vue'
import StatementOfCostsTable from './vue-components/statement-of-costs-table.vue'

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('body.event-reimbursements, body.event-preview')) {
    const reimbursementManagerEl = document.querySelector('div[data-is="ReimbursementManager"]')
    if (reimbursementManagerEl instanceof HTMLElement) {
      window.reimbursementManager = tsInitVue(ReimbursementManager, reimbursementManagerEl, {
        initialFiles: window.reimbursementFiles,
        uploadUrl: reimbursementManagerEl.dataset.uploadUrl,
        requireAttendanceCertificate: reimbursementManagerEl.dataset.requireAttendanceCertificate == 'true',
        filesTitle: reimbursementManagerEl.dataset.filesTitle,
      })
    }


    const statementOfCostsTableEl = document.querySelector('div[data-is="StatementOfCostsTable"]')
    if (statementOfCostsTableEl instanceof HTMLElement) {
      window.statementOfCostsTable = tsInitVue(StatementOfCostsTable, statementOfCostsTableEl, {
        itemsJsonElRef: statementOfCostsTableEl.dataset.itemsJsonElRef,
        uploadUrl: statementOfCostsTableEl.dataset.uploadUrl,
      })
    }

    const formEl = document.querySelector('form[ref="reimbursement-files-form"]')
    if (formEl && window.statementOfCostsTable) {
      formEl.addEventListener('submit', function (e) {
        if (window.statementOfCostsTable.isEditing) {
          alert('Please save the row in statements of costs table by pressing "Save this entry"')
          e.preventDefault()
          // e.stopPropagation()
          return false
        }
      })
    }
  }
})

$(function() {
  if ($('.survey-questions').length) {
    const setRatingState = function (rc: Element, valField: HTMLInputElement): void {
      // reset state for rating buttons
      $(rc).find('button.rating-button').removeClass('btn-secondary').addClass('btn-outline-secondary')
      if (valField.value) {
        $(rc).find(`button.rating-button[data-value="${valField.value}"]`).removeClass('btn-outline-secondary').addClass('btn-secondary')
      }
    }
    for (const rc of $('.survey-questions .rating-control').toArray()) {
      const valField = $(rc).find('input[type=hidden]:first').get(0)
      if (valField instanceof HTMLInputElement) {
        setRatingState(rc, valField)
        $(rc).on('click', 'button.rating-button', function () {
          const newValue = $(this).data('value')
          if (newValue.toString() == valField.value) {
            // unset current selection
            valField.value = ''
          } else {
            // make new selection
            valField.value = newValue
          }
          setRatingState(rc, valField)
        })
      }
    }

    // handle notes field for .single-choice-control
    for (const scc of $('.survey-questions .single-choice-control').toArray()) {
      const $scc = $(scc)

      // hide all choice notes
      const $noteElements = $scc.find('.choice-note')
      $noteElements.addClass('d-none')

      // show notes for checked items
      const $selectedEl = $scc.find('input:checked')
      if ($selectedEl.length > 0) {
        $scc.find(`.choice-note[ref="note-${$selectedEl.attr('id')}"]`).removeClass('d-none')
      }

      $scc.find('input[type="radio"]').on('change', function () {
        // hide all notes fields
        $noteElements.addClass('d-none')
        if (this instanceof HTMLInputElement && this.checked) {
          // show note element if any
          $scc.find(`.choice-note[ref="note-${$(this).attr('id')}"]`).removeClass('d-none')
        }
      })
    }

    // handle notes field for .multiple-choice-control
    for (const nf of $('.survey-questions .multiple-choice-control .choice-note').toArray()) {
      const $notesField = $(nf)
      const refVal = $notesField.attr('ref')

      if (isNonEmptyString(refVal)) {
        // refVal is in form note-`check el id`
        const $checkEl = $(`#${refVal.substr('note-'.length)}`)

        if ($checkEl.is(':checked')) {
          // show notes field
          $notesField.removeClass('d-none')
        } else {
          // hide notes field
          $notesField.addClass('d-none')
        }

        $checkEl.on('change', function () {
          const $checkEl = $(this)
          if ($checkEl.is(':checked')) {
            $notesField.removeClass('d-none')
          } else {
            $notesField.addClass('d-none')
          }
        })
      }
    }

    // instructor question control
    for (const iqc of $('.survey-questions .instructor-assessment-control .instructor').toArray()) {
      const $sq = $(iqc).find('.sub-questions:first')
      const sqEl = $sq.get(0)

      const $cb = $(iqc).find('[ref="applicable-cb"]:first')
      const cbEl = $cb.get(0)
      if (sqEl && cbEl instanceof HTMLInputElement) {
        if (cbEl.checked) {
          $sq.addClass('collapse')
        } else {
          $sq.addClass('collapse show')
        }
        const sqCollapse = Collapse.getOrCreateInstance(sqEl, { toggle: false })
        $cb.on('change', function () {
          if (this instanceof HTMLInputElement) {
            if (this.checked) {
              sqCollapse.hide()
            } else {
              sqCollapse.show()
            }
          }
        })
      }
    }
  }
})
